import { render } from "./ToolbarItemHome.vue?vue&type=template&id=79c904d2&ts=true"
import script from "./ToolbarItemHome.vue?vue&type=script&lang=ts"
export * from "./ToolbarItemHome.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ToolbarItemHome.vue?vue&type=style&index=0&id=79c904d2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__